module.exports = __webpack_public_path__ + "blueprint-red-no-labels-selector.f459fa31e775484fd817.png";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/blueprint-red-no-labels-selector.png
// module id = ../../../../../src/assets/img/blueprint-red-no-labels-selector.png
// module chunks = main